import { CanDeactivateFn } from '@angular/router';
import { UserInvitePageComponent } from './user-invite-page.component';

export const canDeactivateUserInvitePage: CanDeactivateFn<UserInvitePageComponent> = (component) => {
  if (component.hasUnsavedChanges()) {
    return component.confirmDeactivate();
  }
  return true;
};
